import React, { useState } from "react";
import "../../styles/App.css";

const HraCalculator = () => {
  const [basicSalary, setBasicSalary] = useState<number>(0);
  const [daReceived, setDaReceived] = useState<number>(0);
  const [hraReceived, setHraReceived] = useState<number>(0);
  const [rentPaid, setRentPaid] = useState<number>(0);
  const [isMetroCity, setIsMetroCity] = useState<boolean>(false);

  const calculateHra = () => {
    const salaryForCalculation = basicSalary + daReceived;
    const actualHraReceived = hraReceived;
    const percentageOfSalary = isMetroCity ? 0.5 * basicSalary : 0.4 * basicSalary;
    const rentMinus10PercentSalary = rentPaid - 0.1 * salaryForCalculation;

    const exemptedHra = Math.min(
      actualHraReceived,
      percentageOfSalary,
      rentMinus10PercentSalary > 0 ? rentMinus10PercentSalary : 0
    );

    const taxableHra = actualHraReceived - exemptedHra;

    return {
      exemptedHra,
      taxableHra,
    };
  };

  const { exemptedHra, taxableHra } = calculateHra();

  return (
    <div className="hra-calculator">
      <h2>HRA Calculator</h2>

      <label>Basic Salary Received:</label>
      <input
        type="number"
        value={basicSalary}
        onChange={(e) => setBasicSalary(Number(e.target.value))}
        className="input-full-width"
      />

      <label>Dearness Allowance (DA) Received:</label>
      <input
        type="number"
        value={daReceived}
        onChange={(e) => setDaReceived(Number(e.target.value))}
        className="input-full-width"
      />

      <label>HRA Received:</label>
      <input
        type="number"
        value={hraReceived}
        onChange={(e) => setHraReceived(Number(e.target.value))}
        className="input-full-width"
      />

      <label>Total Rent Paid:</label>
      <input
        type="number"
        value={rentPaid}
        onChange={(e) => setRentPaid(Number(e.target.value))}
        className="input-full-width"
      />

      <div className="radio-group">
        <label>Do you live in Delhi, Mumbai, Kolkata, or Chennai?</label>
        <br />
        <label>
          <input
            type="radio"
            checked={isMetroCity}
            onChange={() => setIsMetroCity(true)}
          />
          Yes
        </label>
        <label className="radio-margin">
          <input
            type="radio"
            checked={!isMetroCity}
            onChange={() => setIsMetroCity(false)}
          />
          No
        </label>
      </div>

      <hr />

      <h3>Results:</h3>
      <p><strong>Amount of Exempted HRA:</strong> ₹{exemptedHra.toLocaleString()}</p>
      <p><strong>HRA Chargeable to Tax:</strong> ₹{taxableHra.toLocaleString()}</p>
    </div>
  );
};

export default HraCalculator;
